/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_LIST_COUNTRY_STATES,
  GET_ECP_CATEGORIES,
  ADD_CLAIM,
  UPDATE_CLAIM,
  GET_CLAIMS,
  UPDATE_MEMBER,
  CLEAR_TOAST_MESSAGE_NOTIFICATION,
  SET_DEALER_INFO,
  SET_ORDER_INFO,
  SET_CLAIM_INFO

} from 'src/actions/claimActions';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';

const initialState = {
  appSettings: null,
  countryStates: [],
  claims: [],
  customerInfo: {},
  vehicleInformation: {},
  causeOfLoss: {},
  memberPolicyDetail: {},
  claimInfo: {},
  memberInfo: {
    id: 0,
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    zipCode2: '',
    dateOfLoss: new Date(),
    causeOfDamage: null
  },
  ecpCategories: {}
};

const claimReducer = (state = initialState, action) => {
  switch (action.type) {

    case GET_CLAIMS: {
      const claims = action.payload;
      return produce(state, (draft) => {
        draft.claims = claims;
      });
    }

    case SET_ORDER_INFO: {
      const orderInfo = action.payload;
      return produce(state, (draft) => {
        draft.orderInfo = orderInfo;
      });
    }

    case SET_CLAIM_INFO: {
      const claimInfo = action.payload;
      return produce(state, (draft) => {
        draft.claimInfo = claimInfo;
      });
    }

    case SET_DEALER_INFO: {
      const dealerInfo = action.payload;
      return produce(state, (draft) => {
        draft.dealerInfo = dealerInfo;
      });
    }

    case UPDATE_MEMBER: {
      const member = action.payload;

      return produce(state, (draft) => {
        draft.memberInfo = member;
      });
    }

    case CLEAR_TOAST_MESSAGE_NOTIFICATION: {

      return produce(state, (draft) => {
        draft.successMessage = null;
        draft.errorMessage = null;
        draft.errorId = null;
      });

    }

    case UPDATE_CLAIM: {
      const { claim } = action.payload;
      return produce(state, (draft) => {
        let i = findIndex(draft.claims, { id: claim.id });
        draft.claims[i] = claim;
      });
    }

    case ADD_CLAIM: {
      const { claim } = action.payload;
      return produce(state, (draft) => {
        if (!find(draft.claims, { id: claim.id })) {
          draft.claims.push(claim);
        }
      });
    }

    case GET_LIST_COUNTRY_STATES: {
      const { CountryStates } = action.payload;

      return produce(state, (draft) => {
        // Ensure we clear current session
        draft.countryStates = CountryStates;
      });
    }

    case GET_ECP_CATEGORIES: {
      const { ecpCategories } = action.payload;

      return produce(state, (draft) => {
        draft.ecpCategories = ecpCategories;
      });
    }

    default: {
      return state;
    }
  }
};

export default claimReducer;
